import { API, VIEW_HOME, VIEW_LOGIN, VIEW_REGISTER, VIEW_WELCOME } from '../../common/EsConstants';

// Pages for somebody who is not signed in, plus the page a login lands on anyway.
// A saved destination naming one of them is ignored, never returned to -- Tim,
// 2026-10-01. esback's EsLoginSuccessHandler keeps the same list for Google.
const NOT_DESTINATIONS = [ VIEW_HOME, VIEW_LOGIN, VIEW_REGISTER, VIEW_WELCOME ];

// The rule esback's EsAuthController.isPagePath applies, so the two never disagree. A
// pathname is whatever the address bar held: https://escapade.gg//evil.com/x has the
// pathname //evil.com/x, which window.location.assign reads as another host.
const isPagePath = ( pPath ) => pPath.length <= 512 && pPath.startsWith( '/' )
    && !pPath.startsWith( '//' ) && !pPath.startsWith( API )
    && ![ ...pPath ].some( ( pChar ) => pChar === '\\' || pChar < ' ' );

/**
 * The page a login should return to, or null for "the welcome page".
 *
 * <p>Read off the router state RequireAuth (or the opt-out page) set when it sent
 * the reader to the login. It lives on that one history entry, so a login started
 * later from the front page carries nothing and goes to welcome: the destination is
 * used once, by the login that was sent for it.
 *
 * @param pLocation what useLocation() answered on the login page
 */
export function esLoginDestination( pLocation ) {
    const aFrom = pLocation?.state?.from;
    const aPath = aFrom?.pathname;

    if ( !aPath || NOT_DESTINATIONS.includes( aPath ) ) return null;

    const aDestination = aPath + ( aFrom.search || '' ) + ( aFrom.hash || '' );
    return isPagePath( aDestination ) ? aDestination : null;
}
